import { Link } from "@solidjs/router";
import { Nav, Navbar, NavDropdown } from "solid-bootstrap";
import { VoidComponent } from "solid-js";

export const OneSysHeader: VoidComponent = () => {
	return (
		<Navbar
			expand="lg"
			class="p-3 d-flex flex-row justify-content-between align-items-center"
			style="z-index:1;">
			<a
				target="_blank"
				href="https://onesys.gr/"
				style="max-height: 42.5px;">
				<img
          src="/logo.jpg"
					alt="OneSys IT Solutions"
					width="90"
					height="30">
				</img>
			</a>

			<Navbar.Toggle aria-controls="responsive-header" />
			<Navbar.Collapse
				id="responsive-header">
				<Nav.Link
					href="https://onesys.gr/#home"
					class="header-link me-2">Home</Nav.Link>
				<Nav.Link
					href="https://onesys.gr/#who-we-are"
					class="header-link me-2">Who we are</Nav.Link>
				<Nav.Link
					href="https://onesys.gr/#products"
					class="header-link me-2">Products</Nav.Link>
				<NavDropdown
					title="IT Services"
					class="me-2">
						<ul class="undecorated-list w300px">
							<li>
								<NavDropdown.Item
									href="https://onesys.gr/#advanced-services"
									class="p-2">Advanced Services</NavDropdown.Item>
							</li>
							<li>
								<NavDropdown.Item
									href="https://onesys.gr/#custom-solutions-provider"
									class="p-2">Custom Solutions Provider</NavDropdown.Item>
							</li>
						</ul>
				</NavDropdown>
				<Nav.Link
					href="https://onesys.gr/#technologies"
					class="header-link me-2">Technologies</Nav.Link>
				<Nav.Link
					href="https://onesys.gr/#partnerships"
					class="header-link me-2">Partnerships</Nav.Link>
				<Nav.Link
					href="https://onesys.gr/#contact"
					class="header-link me-2">Contact</Nav.Link>
			</Navbar.Collapse>
		</Navbar>
	);
}